import Mapper from '@web/mapper/Mapper'
import { RawSubscription } from '@web/types/Subscription'
import Time from '@web/common/Time'

export default class SubscriptionMapper extends Mapper {
  static toClient (data: unknown): RawSubscription {
    const convertedData = SubscriptionMapper.converter({
      data,
      rules: {
        period: {
          rename: 'interval'
        },
        period_count: {
          rename: 'period'
        },
        activeFreeze: {
          cb: activeFreeze => {
            if (!activeFreeze) return undefined

            return {
              id: activeFreeze.id,
              startedAt: activeFreeze.started_at ? activeFreeze.started_at * 1000 : undefined,
              expiresAt: activeFreeze.expires_at ? activeFreeze.expires_at * 1000 : undefined,
              endedAt: activeFreeze.ended_at ? activeFreeze.ended_at * 1000 : undefined
            }
          }
        }
      }
    }) as RawSubscription

    if (!convertedData.nextPayAt && convertedData.endDate) {
      convertedData.nextPayAt = Time(convertedData.endDate, 'YYYY-MM-DD')
        .set('hours', 0)
        .set('minutes', 0)
        .set('seconds', 0)
        .set('milliseconds', 0)
        .unix() * 1000
    }

    return convertedData
  }
}
